import { C1DisplayNameSkeleton } from 'components/core/display-name-details'
import { MinimalAPIError } from 'components/core/errors/api'
import {
    C1AccessReviewDisplayName,
    C1AccessReviewDisplayNameProps,
} from 'components/pages/accessreview/display-name/C1AccessReviewDisplayName'
import { AccessReviewServiceGetRequest } from 'pbts/c1/api/accessreview/v1/accessreview'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getAccessReviewApi } from 'redux_toolkit/access-reviews'

export type C1AccessReviewDisplayNameWithFetchProps = {
    accessReviewId: string
} & Omit<C1AccessReviewDisplayNameProps, 'accessReview'>

export const C1AccessReviewDisplayNameWithFetch: FC<C1AccessReviewDisplayNameWithFetchProps> = ({
    accessReviewId,
    ...rest
}) => {
    const { data, error, isLoading, isError } = getAccessReviewApi.useGet(
        AccessReviewServiceGetRequest.create({ id: accessReviewId }),
        { actionable: !!accessReviewId },
    )

    if (isLoading) {
        return <C1DisplayNameSkeleton />
    }

    if ((isError && error) || !data) {
        return <MinimalAPIError
            err={<FormattedMessage id="component_api_error_access_review" defaultMessage="Error fetching campaign" />}
        />
    }

    return <C1AccessReviewDisplayName
        {...rest}
        accessReview={data}
    />
}
